import { Box } from 'components';
import * as bi from 'react-bootstrap-icons';
import './style.scss';

interface IProps {
  checked?: boolean;
  onChange?: (value: boolean) => void;
  children?: React.ReactNode;
}

function Checkbox(props: IProps) {
  return (
    <div
      className='cb-NrJs'
      onClick={() => props.onChange?.(!props.checked)}
    >
      <Box
        variant='darker'
        shadow='inside'
        className='cb-ch-Ntud'
      >
        {props.checked && <bi.Check />}
      </Box>
      <span>{props.children}</span>
    </div>
  );
}

export default Checkbox;
